module.exports = __webpack_public_path__ + "img/fluids.7c54945e.svg";